var _path, _g, _path2, _path3, _circle, _path4, _g2, _circle2, _rect, _rect2, _rect3, _path5, _circle3, _path6, _g3, _circle4, _rect4, _rect5, _rect6, _rect7, _rect8, _path7, _circle5, _path8, _g4, _circle6, _rect9, _rect0, _rect1, _g5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZeroStateItemEn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 911 695",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_31_2312",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 473,
    height: 198
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H473L413 198H0V0Z",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_31_2312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M398 65.5C398 29.6015 427.101 0 463 0V0C498.899 0 528 29.6015 528 65.5V65.5C528 101.399 498.899 131 463 131V131C427.101 131 398 101.399 398 65.5V65.5Z",
    fill: "#2F2F30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.25 85.625C445.25 79.2737 452.973 74.125 462.5 74.125C472.027 74.125 479.75 79.2737 479.75 85.625",
    stroke: "#8B8B8B",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.5 65.5C468.851 65.5 474 60.3513 474 54C474 47.6487 468.851 42.5 462.5 42.5C456.149 42.5 451 47.6487 451 54C451 60.3513 456.149 65.5 462.5 65.5Z",
    stroke: "#8B8B8B",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 147,
    width: 35.0382,
    height: 20,
    rx: 10,
    fill: "#959598"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432.718,
    y: 147,
    width: 106.282,
    height: 20,
    rx: 10,
    fill: "#959598"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205 65.5C205 29.6015 234.101 0 270 0V0C305.899 0 335 29.6015 335 65.5V65.5C335 101.399 305.899 131 270 131V131C234.101 131 205 101.399 205 65.5V65.5Z",
    fill: "#2F2F30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.25 85.625C252.25 79.2737 259.973 74.125 269.5 74.125C279.027 74.125 286.75 79.2737 286.75 85.625",
    stroke: "#8B8B8B",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.5 65.5C275.851 65.5 281 60.3513 281 54C281 47.6487 275.851 42.5 269.5 42.5C263.149 42.5 258 47.6487 258 54C258 60.3513 263.149 65.5 269.5 65.5Z",
    stroke: "#8B8B8B",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193,
    y: 147,
    width: 153,
    height: 20,
    rx: 10,
    fill: "#959598"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 65.5C12 29.6015 41.1015 0 77 0V0C112.899 0 142 29.6015 142 65.5V65.5C142 101.399 112.899 131 77 131V131C41.1015 131 12 101.399 12 65.5V65.5Z",
    fill: "#2F2F30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.25 85.625C59.25 79.2737 66.9731 74.125 76.5 74.125C86.0269 74.125 93.75 79.2737 93.75 85.625",
    stroke: "#8B8B8B",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5 65.5C82.8513 65.5 88 60.3513 88 54C88 47.6487 82.8513 42.5 76.5 42.5C70.1487 42.5 65 47.6487 65 54C65 60.3513 70.1487 65.5 76.5 65.5Z",
    stroke: "#8B8B8B",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 147,
    width: 35.0382,
    height: 20,
    rx: 10,
    fill: "#959598"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.7178,
    y: 147,
    width: 106.282,
    height: 20,
    rx: 10,
    fill: "#959598"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_31_2312",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 439,
    y: 0,
    width: 472,
    height: 198
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M499 0H911V198H439L499 0Z",
    fill: "#C4C4C4"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_31_2312)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M384 0H514V131H384V0Z",
    fill: "#2F2F30"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 448.5,
    cy: 65.5,
    r: 26,
    stroke: "#8B8B8B",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_31_2312",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 427,
    y: 43,
    width: 22,
    height: 23
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M433.5 48.5L427.5 56.5L448.5 65.5L447.5 43L433.5 48.5Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_31_2312)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M448.5 81C457.613 81 464 74.6127 464 65.5C464 56.3873 457.613 50 448.5 50C439.387 50 433 56.3873 433 65.5C433 74.6127 439.387 81 448.5 81ZM448.5 85C459.27 85 468 76.2696 468 65.5C468 54.7304 459.27 46 448.5 46C437.73 46 429 54.7304 429 65.5C429 76.2696 437.73 85 448.5 85Z",
    fill: "#8B8B8B"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 449,
    cy: 66,
    r: 3.5,
    stroke: "#8B8B8B",
    strokeWidth: 5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 398.862,
    y: 147,
    width: 68.3244,
    height: 20,
    rx: 10,
    fill: "#959598"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 476.53,
    y: 147,
    width: 48.4695,
    height: 20,
    rx: 10,
    fill: "#959598"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 446.152,
    y: 178,
    width: 63.8473,
    height: 20,
    rx: 10,
    fill: "#4A4A4A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M577 0H707V131H577V0Z",
    fill: "#2F2F30"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 641.5,
    cy: 65.5,
    r: 26,
    stroke: "#8B8B8B",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_31_2312",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 620,
    y: 43,
    width: 22,
    height: 23
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M626.5 48.5L620.5 56.5L641.5 65.5L640.5 43L626.5 48.5Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_31_2312)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M641.5 81C650.613 81 657 74.6127 657 65.5C657 56.3873 650.613 50 641.5 50C632.387 50 626 56.3873 626 65.5C626 74.6127 632.387 81 641.5 81ZM641.5 85C652.27 85 661 76.2696 661 65.5C661 54.7304 652.27 46 641.5 46C630.73 46 622 54.7304 622 65.5C622 76.2696 630.73 85 641.5 85Z",
    fill: "#8B8B8B"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 642,
    cy: 66,
    r: 3.5,
    stroke: "#8B8B8B",
    strokeWidth: 5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 565,
    y: 147,
    width: 35.0382,
    height: 20,
    rx: 10,
    fill: "#959598"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 611.718,
    y: 147,
    width: 106.282,
    height: 20,
    rx: 10,
    fill: "#959598"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 580,
    y: 178,
    width: 14.5534,
    height: 20,
    rx: 7.27672,
    fill: "#4A4A4A"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 601.596,
    y: 178,
    width: 54.9275,
    height: 20,
    rx: 10,
    fill: "#4A4A4A"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 664.034,
    y: 178,
    width: 38.9657,
    height: 20,
    rx: 10,
    fill: "#4A4A4A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M770 0H900V131H770V0Z",
    fill: "#2F2F30"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 834.5,
    cy: 65.5,
    r: 26,
    stroke: "#8B8B8B",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_31_2312",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 813,
    y: 43,
    width: 22,
    height: 23
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M819.5 48.5L813.5 56.5L834.5 65.5L833.5 43L819.5 48.5Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_31_2312)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M834.5 81C843.613 81 850 74.6127 850 65.5C850 56.3873 843.613 50 834.5 50C825.387 50 819 56.3873 819 65.5C819 74.6127 825.387 81 834.5 81ZM834.5 85C845.27 85 854 76.2696 854 65.5C854 54.7304 845.27 46 834.5 46C823.73 46 815 54.7304 815 65.5C815 76.2696 823.73 85 834.5 85Z",
    fill: "#8B8B8B"
  }))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 835,
    cy: 66,
    r: 3.5,
    stroke: "#8B8B8B",
    strokeWidth: 5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 758,
    y: 147,
    width: 153,
    height: 20,
    rx: 10,
    fill: "#959598"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 832.152,
    y: 178,
    width: 63.8473,
    height: 20,
    rx: 10,
    fill: "#4A4A4A"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 773,
    y: 178,
    width: 51.6412,
    height: 20,
    rx: 10,
    fill: "#4A4A4A"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dddddd_31_2312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M605.5 239V511C605.5 512.933 603.933 514.5 602 514.5H309C307.067 514.5 305.5 512.933 305.5 511V239C305.5 237.067 307.067 235.5 309 235.5H438.958C439.903 235.5 440.824 235.202 441.59 234.65L453.452 226.093C454.675 225.212 456.325 225.212 457.548 226.093L469.41 234.65C470.176 235.202 471.097 235.5 472.042 235.5H602C603.933 235.5 605.5 237.067 605.5 239Z",
    fill: "#23262D",
    stroke: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329,
    y: 270,
    width: 21.1794,
    height: 20,
    rx: 10,
    fill: "#404648"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.428,
    y: 270,
    width: 79.9351,
    height: 20,
    rx: 10,
    fill: "#404648"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 451.294,
    y: 270,
    width: 56.7061,
    height: 20,
    rx: 10,
    fill: "#404648"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31_2312)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 329,
    y: 399,
    width: 46.2595,
    height: 20,
    rx: 10,
    fill: "#404648"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.68,
    y: 399,
    width: 140.321,
    height: 20,
    rx: 10,
    fill: "#404648"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 444.42,
    y: 457,
    width: 124.58,
    height: 20,
    rx: 10,
    fill: "#404648"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329,
    y: 457,
    width: 100.763,
    height: 20,
    rx: 10,
    fill: "#404648"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305,
    y: 313,
    width: 301,
    height: 60,
    fill: "#C4C4C4",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.954 354H329.735L337.416 332.182H342.295L349.987 354H345.768L339.941 336.656H339.771L333.954 354ZM334.092 345.445H345.598V348.62H334.092V345.445ZM358.265 354.288C356.979 354.288 355.829 353.957 354.813 353.297C353.798 352.636 352.995 351.678 352.406 350.42C351.816 349.163 351.521 347.636 351.521 345.839C351.521 344.021 351.82 342.487 352.416 341.237C353.02 339.98 353.833 339.032 354.856 338.393C355.879 337.746 357.018 337.423 358.276 337.423C359.234 337.423 360.023 337.587 360.641 337.913C361.259 338.233 361.749 338.62 362.111 339.075C362.473 339.522 362.754 339.945 362.952 340.342H363.112V332.182H366.979V354H363.187V351.422H362.952C362.754 351.82 362.466 352.242 362.089 352.69C361.713 353.13 361.216 353.506 360.598 353.819C359.98 354.131 359.202 354.288 358.265 354.288ZM359.341 351.124C360.158 351.124 360.854 350.903 361.429 350.463C362.004 350.016 362.441 349.394 362.739 348.599C363.038 347.803 363.187 346.876 363.187 345.818C363.187 344.76 363.038 343.84 362.739 343.059C362.448 342.278 362.015 341.67 361.44 341.237C360.871 340.804 360.172 340.587 359.341 340.587C358.482 340.587 357.764 340.811 357.189 341.259C356.614 341.706 356.18 342.324 355.889 343.112C355.598 343.901 355.452 344.803 355.452 345.818C355.452 346.841 355.598 347.754 355.889 348.556C356.188 349.352 356.624 349.98 357.2 350.442C357.782 350.896 358.496 351.124 359.341 351.124ZM377.161 354.288C375.876 354.288 374.725 353.957 373.71 353.297C372.694 352.636 371.892 351.678 371.302 350.42C370.713 349.163 370.418 347.636 370.418 345.839C370.418 344.021 370.716 342.487 371.313 341.237C371.916 339.98 372.73 339.032 373.752 338.393C374.775 337.746 375.915 337.423 377.172 337.423C378.131 337.423 378.919 337.587 379.537 337.913C380.155 338.233 380.645 338.62 381.007 339.075C381.369 339.522 381.65 339.945 381.849 340.342H382.009V332.182H385.876V354H382.083V351.422H381.849C381.65 351.82 381.362 352.242 380.986 352.69C380.61 353.13 380.112 353.506 379.494 353.819C378.877 354.131 378.099 354.288 377.161 354.288ZM378.237 351.124C379.054 351.124 379.75 350.903 380.325 350.463C380.901 350.016 381.338 349.394 381.636 348.599C381.934 347.803 382.083 346.876 382.083 345.818C382.083 344.76 381.934 343.84 381.636 343.059C381.345 342.278 380.911 341.67 380.336 341.237C379.768 340.804 379.068 340.587 378.237 340.587C377.378 340.587 376.661 340.811 376.085 341.259C375.51 341.706 375.077 342.324 374.786 343.112C374.494 343.901 374.349 344.803 374.349 345.818C374.349 346.841 374.494 347.754 374.786 348.556C375.084 349.352 375.521 349.98 376.096 350.442C376.678 350.896 377.392 351.124 378.237 351.124ZM405.598 337.636V340.619H396.191V337.636H405.598ZM398.513 333.716H402.37V349.078C402.37 349.597 402.448 349.994 402.604 350.271C402.768 350.541 402.981 350.726 403.244 350.825C403.506 350.925 403.798 350.974 404.117 350.974C404.359 350.974 404.579 350.957 404.778 350.921C404.984 350.886 405.14 350.854 405.246 350.825L405.896 353.84C405.69 353.911 405.396 353.989 405.012 354.075C404.636 354.16 404.174 354.21 403.627 354.224C402.661 354.252 401.791 354.107 401.017 353.787C400.243 353.46 399.629 352.956 399.174 352.274C398.727 351.592 398.506 350.74 398.513 349.717V333.716ZM415.785 354.32C414.187 354.32 412.802 353.968 411.631 353.265C410.459 352.562 409.55 351.578 408.903 350.314C408.264 349.05 407.944 347.572 407.944 345.882C407.944 344.192 408.264 342.711 408.903 341.44C409.55 340.168 410.459 339.181 411.631 338.478C412.802 337.775 414.187 337.423 415.785 337.423C417.383 337.423 418.768 337.775 419.94 338.478C421.112 339.181 422.018 340.168 422.657 341.44C423.303 342.711 423.626 344.192 423.626 345.882C423.626 347.572 423.303 349.05 422.657 350.314C422.018 351.578 421.112 352.562 419.94 353.265C418.768 353.968 417.383 354.32 415.785 354.32ZM415.807 351.23C416.673 351.23 417.398 350.992 417.98 350.516C418.562 350.033 418.996 349.387 419.28 348.577C419.571 347.768 419.716 346.866 419.716 345.871C419.716 344.87 419.571 343.964 419.28 343.155C418.996 342.338 418.562 341.688 417.98 341.205C417.398 340.722 416.673 340.481 415.807 340.481C414.919 340.481 414.18 340.722 413.591 341.205C413.008 341.688 412.572 342.338 412.28 343.155C411.996 343.964 411.854 344.87 411.854 345.871C411.854 346.866 411.996 347.768 412.28 348.577C412.572 349.387 413.008 350.033 413.591 350.516C414.18 350.992 414.919 351.23 415.807 351.23ZM434.341 354V337.636H438.027V340.417H438.219C438.56 339.479 439.124 338.748 439.913 338.222C440.701 337.69 441.642 337.423 442.736 337.423C443.844 337.423 444.778 337.693 445.538 338.233C446.305 338.766 446.844 339.494 447.157 340.417H447.327C447.69 339.508 448.3 338.783 449.16 338.244C450.026 337.697 451.053 337.423 452.239 337.423C453.744 337.423 454.973 337.899 455.925 338.851C456.876 339.803 457.352 341.191 457.352 343.016V354H453.485V343.613C453.485 342.597 453.215 341.855 452.675 341.386C452.136 340.911 451.475 340.673 450.694 340.673C449.763 340.673 449.036 340.964 448.51 341.546C447.991 342.121 447.732 342.871 447.732 343.794V354H443.95V343.453C443.95 342.608 443.695 341.933 443.183 341.429C442.679 340.925 442.018 340.673 441.202 340.673C440.648 340.673 440.143 340.815 439.689 341.099C439.234 341.376 438.872 341.77 438.602 342.281C438.332 342.786 438.197 343.375 438.197 344.05V354H434.341ZM461.265 354V337.636H465.121V354H461.265ZM463.204 335.314C462.593 335.314 462.067 335.112 461.627 334.707C461.187 334.295 460.966 333.801 460.966 333.226C460.966 332.643 461.187 332.15 461.627 331.745C462.067 331.333 462.593 331.127 463.204 331.127C463.822 331.127 464.347 331.333 464.78 331.745C465.221 332.15 465.441 332.643 465.441 333.226C465.441 333.801 465.221 334.295 464.78 334.707C464.347 335.112 463.822 335.314 463.204 335.314ZM472.24 337.636L475.543 343.677L478.899 337.636H482.979L478.047 345.818L483.064 354H479.005L475.543 348.109L472.113 354H468.022L473.007 345.818L468.15 337.636H472.24Z",
    fill: "#35FFD0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dddddd_31_2312",
    x: 225,
    y: 224,
    width: 461,
    height: 471,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.76726
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.1069
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0196802 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_31_2312"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.6501
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.66004
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0282725 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_31_2312",
    result: "effect2_dropShadow_31_2312"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12.5216
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.00862
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.035 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_31_2312",
    result: "effect3_dropShadow_31_2312"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 22.3363
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.93452
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0417275 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_31_2312",
    result: "effect4_dropShadow_31_2312"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 41.7776
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.711
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0503198 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_31_2312",
    result: "effect5_dropShadow_31_2312"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 100
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_dropShadow_31_2312",
    result: "effect6_dropShadow_31_2312"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect6_dropShadow_31_2312",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31_2312"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 202,
    height: 20,
    fill: "white",
    transform: "translate(329 399)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeroStateItemEn);
export default __webpack_public_path__ + "static/media/zeroState-item-en.628ed39a.svg";
export { ForwardRef as ReactComponent };